// common/latest-articles/latest-articles.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LatestArticlesComponent } from './latest-articles.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [LatestArticlesComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [LatestArticlesComponent]
})
export class LatestArticlesModule {}
